import { render, staticRenderFns } from "./EmployeeBranch.vue?vue&type=template&id=63344243&"
import script from "./EmployeeBranch.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranch.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeBranch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports